import React, { FunctionComponent } from 'react';
import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import routes, { mainRoutes } from '@config/routes';
import useTranslate from '@hooks/useTranslate';
import { values, filter } from 'lodash';
import authStore from '@stores/auth';
import { useStore } from 'effector-react';
import locale from '@stores/locale';
import componentContent from './MainMenu.content.json';
import useGuards from '@hooks/useGuards';

interface MainMenuProps {}

const MainMenu: FunctionComponent<MainMenuProps> = () => {
  const content = useTranslate(componentContent);
  const location = useLocation();
  const selectedKeys = values(routes)
    .filter((route) => location.pathname.includes(route.path))
    .map((route) => route.name);
  const auth = useStore(authStore);
  const localeName = useStore(locale);
  const { isCommunityManager, isModerator, isAdmin } = useGuards();

  const menuItems = filter(routes, (route) => {
    if (isCommunityManager && route.path === routes.featuring.path) {
      return false;
    }
    if (
      isModerator &&
      route.path !== routes.postList.path &&
      route.path !== routes.spamCommon.path &&
      route.path !== routes.games.path &&
      route.path !== routes.tribes.path
    ) {
      return false;
    }
    if (
      !isAdmin &&
      (route.name === 'mentionsOfficialAccountPost' ||
        route.name === 'mentionsOfficialAccountComment' ||
        route.name === 'registrationIps' ||
        route.name === 'blockedEmailDomains')
    ) {
      return false;
    }
    return !!(route.menuSlotes && route.menuSlotes.includes('main') && auth.user);
  });

  const showMenu = menuItems
    .filter((route) => mainRoutes.includes(route.name))
    .map((route) => (
      <Menu.Item key={route.name}>
        <Link to={route.path}>{route.title[localeName]}</Link>
      </Menu.Item>
    ));

  const hideMenu = menuItems
    .filter((route) => !mainRoutes.includes(route.name))
    .map((route) => (
      <Menu.Item key={route.name}>
        <Link to={route.path}>{route.title[localeName]}</Link>
      </Menu.Item>
    ));

  return (
    <Menu
      theme='dark'
      mode='horizontal'
      style={{ width: '100%' }}
      selectedKeys={selectedKeys}
    >
      {showMenu}
      <Menu.SubMenu title={content.other}>{hideMenu}</Menu.SubMenu>
    </Menu>
  );
};

export default MainMenu;
